<template>
    <div class="content-slider-settings">

        <!-- settings group: PARENT BLOCK -->
        <div class="settings-group-title">
            <h6>slider navigation</h6>
        </div>

        <!-- use dots -->
        <div class="setting">
            <!-- label background type -->
            <label>Use navigation dots:</label>
            <!-- background type child -->
            <div class="setting setting-toggle-group">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.dots" @change="reloadFlickity()">
                    Dots
                </b-form-checkbox>
            </div>
        </div>

        <!-- dots position -->
        <div class="setting" v-if="settingsFromWeebly.settings.dots">
            <b-form-group>

                <label>Dots position:</label>
                <b-form-select v-model="settingsFromWeebly.settings.dotsPosition" size="sm">
                    <option value="bottom">Under slider</option>
                    <option value="top">On top of slider</option>
                </b-form-select>

            </b-form-group>
        </div>
        
        <!--  dot accent color -->
        <div class="setting" v-if="settingsFromWeebly.settings.dots">
            <Mycolorpicker elementRef="dotAccentColor" theColorPicker="allpickers" colorPickerName="Accent color dots:" />
        </div>

        <!-- use arrows -->
        <div class="setting">
            <!-- label background type -->
            <label>Use navigation arrows:</label>

            <div class="setting setting-toggle-group">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.arrows" @change="reloadFlickity()">
                    Arrows
                </b-form-checkbox>
            </div>
        </div>

        <!-- arrow size -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <b-form-group>

                <label for="flexchild-arrowsize-input">Arrow size: <span v-b-tooltip.hover.top title="Increase/decrease the size of the arrow"><i class="far fa-question-circle"></i></span></label>
                
                <b-input-group size="sm" append="px">
                    <b-form-input id="flexchild-arrowsize-input" type="number" v-model="settingsFromWeebly.settings.arrowSize" min="5" max="70" step="1" />
                </b-input-group>

            </b-form-group>
        </div> 

        <!-- arrow radius -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <b-form-group>

                <label for="flexchild-arrowradius-input">Arrow radius: <span v-b-tooltip.hover.top title="Roundness of the arrow"><i class="far fa-question-circle"></i></span></label>
                
                <b-input-group size="sm" append="px">
                    <b-form-input id="flexchild-arrowradius-input" type="number" v-model="settingsFromWeebly.settings.arrowRadius" min="0" max="100" step="1" />
                </b-input-group>

            </b-form-group>
        </div> 

        <!--  arrow background color -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <Mycolorpicker elementRef="arrowBg" theColorPicker="allpickers" colorPickerName="Arrow background color:" />
        </div>

        <!--  arrow background color -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <Mycolorpicker elementRef="arrowBgHover" theColorPicker="allpickers" colorPickerName="Arrow background color hover:" />
        </div>

        <!--  arrow color -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <Mycolorpicker elementRef="arrowColor" theColorPicker="allpickers" colorPickerName="Arrow color:" />
        </div>

        <!--  arrow color -->
        <div class="setting" v-if="settingsFromWeebly.settings.arrows">
            <Mycolorpicker elementRef="arrowColorHover" theColorPicker="allpickers" colorPickerName="Arrow color hover:" />
        </div>

        <!-- slider FUNCTIONALITY -->
        <div class="settings-group-title">
            <h6>functionality</h6>
        </div>

        <!-- infinite loop -->
        <div class="setting">
            <b-form-group>

                <label>Infinite loop:</label>
                <b-form-select v-model="settingsFromWeebly.settings.loop" size="sm" @change="reloadFlickity()">
                    <option value="true">Infinite loop</option>
                    <option value="false">Stop at end</option>
                </b-form-select>

            </b-form-group>
        </div>

        <!-- autoplay -->
        <div class="setting">
            <!-- label background type -->
            <label>Use Autplay:</label>
            <!-- background type child -->
            <div class="setting setting-toggle-group">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.autoplay" @change="reloadFlickity()">
                    Autoplay
                </b-form-checkbox>
            </div>
        </div>

        <!-- autoplay speed -->
        <div class="setting" v-if="settingsFromWeebly.settings.autoplay">
            <b-form-group>

                <label for="flexchild-autoplayspeed-input">Autoplay speed: <span v-b-tooltip.hover.top title="time a slide should remain visible, value is set in ms"><i class="far fa-question-circle"></i></span></label>
                
                <b-input-group size="sm" append="ms">
                    <b-form-input id="flexchild-autoplayspeed-input" type="number" v-model="settingsFromWeebly.settings.autoplaySpeed" min="1000" max="10000" step="500" @change="reloadFlickity()" />
                </b-input-group>

            </b-form-group>
        </div> 

        <!-- use as partial slider -->
        <div class="setting">
            <!-- label background type -->
            <label>Partial slider:</label>
            <div class="setting setting-toggle-group">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.partialSlider" @change="reloadFlickity()">
                    Use as partial slider
                </b-form-checkbox>
            </div>
        </div>

        <!-- use spacing for partial -->
        <div class="setting" v-if="settingsFromWeebly.settings.partialSlider">

            <label>Spacing between slides:</label>
            <div class="setting setting-toggle-group">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.useSpacing" @change="reloadFlickity()">
                    Use spacing
                </b-form-checkbox>
            </div>
        </div>

        <!-- full width images at all times -->
        <div class="setting">
            <label>Full width:</label>
            <div class="setting setting-toggle-group">
                <b-form-checkbox switch v-model="settingsFromWeebly.settings.alwaysFullWidthImg" @change="reloadFlickity()">
                    Always set images to full width
                </b-form-checkbox>
            </div>
        </div>


    </div>
</template>

<script>
import Mycolorpicker from './Mycolorpicker'
export default {

    name: 'ImageSliderSettings',

    data() {
        return {

        }
    },

    computed:{

        settingsFromWeebly() {
            return this.$store.state.weeblySettings
        },

        globalSettings() {
            return this.$store.state
        }

    },

    mounted() {

        // this.flickityStart()
        
    },

    components: {
        Mycolorpicker
    },

    methods: {
        
        flickityStart: function() {
            
            setTimeout(()=> {
                // settings
                var wrapAround = this.$store.state.weeblySettings.settings.loop == 'true' || this.$store.state.weeblySettings.settings.loop == true ? true : false
                var autoplay = this.$store.state.weeblySettings.settings.autoplay
                var autoplayspeed = parseInt(this.$store.state.weeblySettings.settings.autoplaySpeed)
                var useDots = this.$store.state.weeblySettings.settings.dots == 'true' || this.$store.state.weeblySettings.settings.dots == true ? true : false
                console.log('use dots: ',useDots)

                var flkty = new Flickity( '.bundle-content-slider', {
                    wrapAround: wrapAround,
                    autoPlay: autoplay ? autoplayspeed : false,
                    pageDots: useDots
                });
            },500)
            
        },

        reloadFlickity() {

            console.log('after setting applied we need to reload flickity again');
            // create it to destroy it
            var flkty = new Flickity( '.bundle-content-slider');
            // destroy it
            flkty.destroy();

            this.flickityStart()

        }

    }
}
</script>

<style lang="less">
@import '../../../less/colors.less';
.errordisplay {
    border: 1px solid @warning_red;
    font-size: 12px;
    padding: 7px;
    font-weight: 700;
    border-radius: .25rem;
    margin: 7px auto;

    h2 {
        font-size: 14px;
    }

    span {
        font-style: italic;
        display: block;
        margin-top: 7px;
        color: @warning_red;
    }
}
</style>




// WEBPACK FOOTER //
// src/components/elements/elementSettings/ImageSliderSettings.vue